import './AppLoadingBar.css'
import { useSelector } from 'react-redux'
import { LoadingBar } from 'components'
import { IRootState } from 'types'

const AppLoadingBar = () => {
  const loading = useSelector((state: IRootState) => state.app.loading)

  return (
    <div className='app-loading-bar'>
      <LoadingBar loading={loading} />
    </div>)
}

export default AppLoadingBar